import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { HttpService } from '../../http/http.service';
import { LoginResponse, UserCredentialsDto } from '../dtos';
import { TokenProviderService } from './token-provider.service';
import { throwError } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class AuthenticationServiceApi {
  public constructor(
    private httpService: HttpService,
    private tokenProvider: TokenProviderService
  ) {}

  public login(connectionId: string, credentials: UserCredentialsDto): Observable<string> {
    return this.httpService
      .post<UserCredentialsDto, LoginResponse>(connectionId, 'AuthenticateUser', credentials)
      .pipe(
        tap((response: LoginResponse) => {
          if (response.Tokens && response.Tokens.AccessToken && response.Tokens.RefreshToken) {
            // New API response format
            this.tokenProvider.saveAccessToken(response.Tokens.AccessToken);
            this.tokenProvider.saveRefreshToken(response.Tokens.RefreshToken);
          } else if (response.Data) {
            // Old API response format
            this.tokenProvider.save(response.Data); // Assuming Data contains the JWT token
          } else {
            // Handle error: neither new nor old format detected
            console.error('Invalid login response format', response.Errors);
            throwError(() => new Error('Invalid login response format'));
          }
        }),
        map((response: LoginResponse) => response.Tokens ? response.Tokens.AccessToken : response.Data)
      );
  }
}
